import get from 'lodash/get';
import {Observable} from 'rxjs/Observable';
import {filterOptionsFactory} from 'viewOptions/factories';
import * as ViewOptionsActions from 'viewOptions/actions';
import * as ResourceActions from 'resources/actions';
import * as ResourceApi from 'api/resources';
import * as PrizeActions from './actions';
import {
  getNamedPrizeFilters,
  getRawPrizeFilters
} from './selectors';

const requestPrizesEpic = (action$, store) => action$.ofType(
  PrizeActions.Types.REQUEST_PRIZES,
  ResourceActions.Types.CREATED_RESOURCE,
  ResourceActions.Types.DELETED_RESOURCE,
  ResourceActions.Types.REFRESH_PAGE,
  ResourceActions.Types.UPDATE_PAGE_NUMBER_FOR_RESOURCE,
  ViewOptionsActions.Types.TOGGLE_SORT_FOR_RESOURCE,
  ViewOptionsActions.Types.REPLACE_FILTER_FOR_RESOURCE,
  ViewOptionsActions.Types.SET_RAW_FILTERS_FOR_RESOURCE
)
  .filter(action => {
    const isSortingOrFiltering = action.type in ViewOptionsActions.Types;
    const isPaging = action.type === ResourceActions.Types.UPDATE_PAGE_NUMBER_FOR_RESOURCE;
    const isRefreshing = action.type === ResourceActions.Types.REFRESH_PAGE;

    if (isSortingOrFiltering || isPaging || isRefreshing) {
      // intercept paging/sorting actions to apply custom sorts and filters.
      return action.resourceType === ResourceApi.Types.Prize;
    }

    const isCreating = action.type === ResourceActions.Types.CREATED_RESOURCE;
    const isDeleting = action.type === ResourceActions.Types.DELETED_RESOURCE;

    if (isCreating || isDeleting) {
      // if a Prize is created or deleted, we want a fresh view of existing Prizes that reflects that change.
      return get(action.resource, 'resourceId.type', null) === ResourceApi.Types.Prize;
    }

    return true;
  })
  .mergeMap(action => {
    const state = store.getState();
    const {currentPrizeType} = state.listPrizes;
    const prizeType = currentPrizeType || action.prizeType;

    // null sortOptions offloads sorting to 'resources' epics
    const sortOptions = null;

    const namedFilters = getNamedPrizeFilters(state);
    const rawFilters = getRawPrizeFilters(state);

    return Observable.of(
      PrizeActions.requestedPrizesAction(prizeType),
      ResourceActions.getResourcePageAction(
        ResourceApi.Types.Prize,
        20,
        action.page || 1,
        sortOptions,
        filterOptionsFactory({
          namedFilters,
          filters: rawFilters.concat({field: 'type', value: prizeType})
        })
      )
    );
  });

const receivedPrizesEpic = action$ => action$.ofType(ResourceActions.Types.RECEIVED_RESOURCE_PAGE)
  .filter(action => action.resourceType === ResourceApi.Types.Prize)
  .mapTo(PrizeActions.receivedPrizesAction());

export default [
  requestPrizesEpic,
  receivedPrizesEpic
];



// WEBPACK FOOTER //
// ./public/pages/ListPrizes/epics.js